import React, { Fragment, useState } from 'react';
import { Redirect } from 'react-router';
import { Link, useHistory } from 'react-router-dom';
import { Field, Form, Formik } from 'formik';

import PageHelmet from 'components/common/Helmet';
import Footer from 'components/footer/Footer';
import Header from 'components/header/Header';
import { Title } from 'components/title/Title';

import { loginSchema } from 'utils/validationSchemas';
import * as typeformEmbed from '@typeform/embed'
import Loader from 'components/Loader';
// import { SignInFacebook } from './SignInFacebook';
import { SignInGoogle } from 'components/login/SignInGoogle';

export const Login = (props) => {

	const { firebase, authUser } = props

	const [error, setError] = useState({})
	const [loading, setLoading] = useState(false)
	const history = useHistory()

	const handleDetailsSubmit = () => {
		history.push('/account')
		popup1.close()
	}

	const popup1 = typeformEmbed.makePopup(
		'https://admin.typeform.com/to/PVhySy',
		{
			mode: 'popup',
			autoClose: 3000,
			hideHeaders: true,
			hideFooters: true,
			onSubmit: handleDetailsSubmit
		}
	)

	const handleLogin = (values, actions) => {
		setLoading(true)
		firebase
			.signInWithEmailAndPassword(values.email, values.password)
			.then(r =>  {
				history.push('/')
				setLoading(false)
				actions.setSubmitting(false);
			})
			.catch(err => {
				setError(err)
				setLoading(false)
				actions.setSubmitting(false);
			})
	}


	return !authUser || (authUser && !authUser.emailVerified) ? (
			<Fragment>
				<PageHelmet pageTitle='Sign In' />

				<Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

				<Title title='Sign In' />

				<div className="contact-form--1 pt--50 pb--50">
					<div className="container">
						<div className="row row--35 align-items-center justify-content-center">
							<div className="col-lg-6">
								<Formik
									initialValues= {{
										email: '',
										password: '',
									}}
									validationSchema= {loginSchema}
									onSubmit={handleLogin}
								>
									{({ errors, getFieldProps, handleSubmit, isSubmitting, touched }) => (
										<div className="form-wrapper">
											<div className="row mt--20 mb--20 justify-content-center">
												<SignInGoogle text='Sign In ' popup1={popup1} setError={setError} />
											</div>
											{ loading
												? <Loader />
												: (
													<div>
														<p className="mb--20 text-center">OR</p>

														<Form onSubmit={handleSubmit}>

															<label htmlFor="email">Enter your Email</label>
															<div className="form-input">
																<Field required label="Your Email" placeholder="name@example.com" id="email" {...getFieldProps('email')} />
																<p className="error">{touched.email && errors.email}</p>
															</div>

															<label htmlFor="password">Enter your Password</label>
															<div className="form-input">
																<Field required icon='lock' id="password" type="password" placeholder="************" {...getFieldProps('password')} />
																<p className="error">{touched.password && errors.password}</p>
															</div>

															<p className="error">{error.message}</p>

															<button className="w-100 rn-button-style--2 btn-solid" disabled={isSubmitting} type="submit" value="submit" name="submit" id="mc-embedded-subscribe">Sign In</button>

														</Form>
														<div className="row--35 text-center">
															<div className="col mt--50">
																<p className="mt--20"><Link to='/forgot-password' >Forgot Password ?</Link></p>
																<h4 className="mt--30"><Link to='/register' >Don't have an account? Sign Up Now</Link></h4>
															</div>
														</div>
													</div>
												)
											}
										</div>
									)}
								</Formik>
							</div>
						</div>
					</div>
				</div>
				<Footer />
			</Fragment>
	) : <Redirect to='/account' />
}


